import React from 'react'

function NoMatch() {
  return (
    <section id={'noMatch'}>
      <h1>{'Coordinate Not Found'}</h1>
      <h2>{'Error 404'}</h2>
      <Bg />
    </section>
  )
}

function Bg() {
  return (
    <div className={'bgWrap'}>
      <div className={'skew-layers'}>
        <div className={'noMatch-l1'} />
        <div className={'noMatch-l2'} />
        <div className={'noMatch-l3'} />
      </div>
    </div>
  )
}

export default NoMatch



// WEBPACK FOOTER //
// ./src/Views/NoMatch/NoMatch.js